<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">

          <el-row :span="2" style="margin-top: 30px;">
              名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input>
          </el-row>



          <el-row :span="2" style="margin-top: 30px;">
              <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
          </el-row>
      </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="300"
              label="名称"
               >
               <template slot-scope="scope">
                   <div @click="to(scope.row.id)">{{scope.row.name}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="300"
              label="备注"
               >
               <template slot-scope="scope">
                   <div @click="changeName(scope.row.id,scope.row.beizhu,2)">{{scope.row.beizhu}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="300"
              label="标签"
               >
               <template slot-scope="scope">
                   <div @click="changeName(scope.row.id,scope.row.lable,3)">{{scope.row.lable}}</div>
               </template>
            </el-table-column>
            <el-table-column
            
              width="600"
              label="标签"
               >
               <template slot-scope="scope">
                 <el-row>
                   <span v-for="(item,index) in scope.row.lables"><span v-if="index > 0" style="font-size: 22px;font-weight: bold;">|</span>{{item}}</span>
                 </el-row>
            
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.num}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="200"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id,scope.$index)">删除</el-col>
                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="changeName(scope.row.id,scope.row.name,1)">修改名称</el-col>
                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="jCopy(scope.row.id)">复制</el-col>
                 </el-row>
               </template>
            </el-table-column>
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
    <el-dialog
      title="确认删除"
      :visible.sync="disDel"
      width="30%"
      center>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDel = false">取 消</el-button>
    	<el-button type="primary" @click="doDel()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="names"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChangeName()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         name:'',
         wangzhi:'',
         names:'',
         disDialogVisible:false,
         changeId:0,
         t:0,
         addImg:'',
         addImgs:'',
         imageId:0,
         seachName:'',
         imgId:0,
         cid:0,
         did:0,
         disDel:false,
         t:0



      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
    jCopy(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjie156Copy'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '复制成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    changeName(id,name,t){
      this.cid = id
      this.names = name
      this.t = t
      this.disDialogVisible = true
    },
    doChangeName(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:this.cid,
          name:this.names,
          t:this.t

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjie156ChangeName'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.cid = 0
           this.t = 0
           this.disDialogVisible = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    to(id){
      this.$router.push({ name:'Yjiangjiem156', query: { id: id }})
    },
    seach(){
      this.loadList();
    },
    ceshi(index,id){
      this.imageId = index
      this.imgId = id
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjie156List'
      })
      .then(res=>{

        this.list = res.data.list;
        this.list.forEach(function(item, index) {
        
              item['lables'] = item['lable'].split(',');
        })
        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },


    doDel(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.did,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjie156Del'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.did = 0
           this.disDel = false
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    del(id,index){
      this.did = id
      this.disDel = true
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.name == ''){
        this.msg('请填写名称','error')
        return false
      }



      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjie156Add',
      	params:{
      		name:this.name,


      	}
      })
      .then(res=>{

        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/yjiangjie156.vue